export default __webpack_public_path__ + "logo-no-bg.4d881dc9.svg";